/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListLivestockVaccinationRulesQueryResponse, ListLivestockVaccinationRulesPathParams, ListLivestockVaccinationRules400, ListLivestockVaccinationRules401, ListLivestockVaccinationRules403, ListLivestockVaccinationRules404, ListLivestockVaccinationRules409, ListLivestockVaccinationRules500 } from "../../types/livestockController/ListLivestockVaccinationRules.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListLivestockVaccinationRulesUrl(organizationId: ListLivestockVaccinationRulesPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock/vaccination-rules` as const }
  return res
}

/**
 * @summary Sanitary-calendar vaccination rules (pure read; defaults are seeded at organization creation)
 * {@link /api/organizations/:organizationId/livestock/vaccination-rules}
 */
export async function listLivestockVaccinationRules(organizationId: ListLivestockVaccinationRulesPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListLivestockVaccinationRulesQueryResponse, ResponseErrorConfig<ListLivestockVaccinationRules400 | ListLivestockVaccinationRules401 | ListLivestockVaccinationRules403 | ListLivestockVaccinationRules404 | ListLivestockVaccinationRules409 | ListLivestockVaccinationRules500>, unknown>({ method : "GET", url : getListLivestockVaccinationRulesUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}